import PropTypes from 'prop-types';
import { Outlet } from 'react-router';
import { useSelector } from 'react-redux';

import { can } from '#/modules/infra/auth/can';
import ErrorPage from '#/modules/infra/router/ErrorPage';

/**
 * 無指定權限碼時顯示 ErrorPage（與 404 同頁；文案不含權限碼）。
 * - `code`：單一碼
 * - `codes` + `mode`：`all`（預設）或 `any`
 * 掛在 AdminLayout Outlet 內時保留 Nav／Aside。
 */
const RequirePermission = ({ code, codes, mode = 'all', children }) => {
  const permissions = useSelector((state) => state.infra.permissions);
  const list = Array.isArray(codes) && codes.length > 0
    ? codes
    : (code ? [code] : []);

  const allowed = mode === 'any'
    ? list.some((item) => can(permissions, item))
    : list.every((item) => can(permissions, item));

  if (!list.length || !allowed) {
    return <ErrorPage />;
  }

  if (children != null) {
    return children;
  }

  return <Outlet />;
};

RequirePermission.propTypes = {
  code: PropTypes.string,
  codes: PropTypes.arrayOf(PropTypes.string),
  mode: PropTypes.oneOf(['all', 'any']),
  children: PropTypes.node,
};

export default RequirePermission;
